import {Component, OnInit} from '@angular/core';
import {UnrAd} from '../../core/api/resources/ad.resource';
import {UnrAdsService} from '../../services/ads.service';

@Component({
  templateUrl: 'ads.component.html',
  selector: 'unr-ads-page',
  styleUrls: [
    'ads.component.scss'
  ]
})
export class UnrAdsComponent implements OnInit {
  ads: UnrAd[] = [];

  constructor(private adsService: UnrAdsService) {
  }

  ngOnInit(): void {
    this.ads = this.adsService.ads;
  }
}
